import { ArticleModel } from './../archive/article.model';

export class RepairModel {
  repairId: number = 0;
  devolutionDetailId: number | null = null;
  maintenanceOrderId: number | null = null;
  consecutive: number = 0;
  articleId: number = 0;
  article: ArticleModel = new ArticleModel();
  detailText: string | null = null;
  quantity: number = 0;
  unitValue: number = 0;
  quantityDelivered: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}